import { Button, Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import React from "react";
import { StyledTextField } from "../../Components/TextField/TextField";

function TrackingCodes({ trackingCodes, setTrackingCodes }) {
  const handleInputNameChange = (index, e) => {
    const items = Array.from(trackingCodes);
    items[index].name = e.target.value;
    setTrackingCodes(items);
  };

  const handleInputCodeChange = (index, e) => {
    const items = Array.from(trackingCodes);
    items[index].value = e.target.value;
    setTrackingCodes(items);
  };

  const handleInputATSChange = (index) => {
    const items = Array.from(trackingCodes);
    items[index].isPassThrough = !items[index].isPassThrough;
    setTrackingCodes(items);
  };

  const handleDeleteCode = (index) => {
    if (trackingCodes.length === 1) {
      return;
    }
    const items = Array.from(trackingCodes);
    items.splice(index, 1);
    setTrackingCodes(items);
  };

  return (
    <>
      {trackingCodes.map((code, index) => (
        <>
          <Grid xs={12} sm={3} item>
            <StyledTextField
              InputLabelProps={{ style: { color: "#82B288" } }}
              placeholder="Tracking Code Name"
              label="Tracking Code Name"
              variant="standard"
              fullWidth
              value={code.name}
              onChange={(e) => handleInputNameChange(index, e)}
            />
          </Grid>
          <Grid xs={12} sm={3} item>
            <StyledTextField
              InputLabelProps={{ style: { color: "#82B288" } }}
              placeholder="Code"
              label="Code"
              variant="standard"
              fullWidth
              value={code.value}
              onChange={(e) => handleInputCodeChange(index, e)}
            />
          </Grid>
          <Grid xs={12} sm={index === 0 ? 4 : 2} item>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={code.isPassThrough}
                  onChange={() => handleInputATSChange(index)}
                />
              }
              label="Pass to ATS"
            />
          </Grid>
          {index !== 0 ? (
            <Grid xs={12} sm={3} item>
              <Button
                style={{ backgroundColor: "#FF3620", marginTop: "0px" }}
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => handleDeleteCode(index)}
              >
                Delete
              </Button>
            </Grid>
          ) : null}
        </>
      ))}
    </>
  );
}

export default TrackingCodes;
